import {
  ModalityRadarApiResponse,
  ModalityRadarResponse,
  PreciseHeatmapApiResponse,
  PreciseHeatmapResponse,
  TimeseriesApiResponse,
} from '@/features/Analytics/interfaces';

import { decodeHtml } from '@/utils/helpers';

const MAX_TIMESERIES_POINTS = 500;

const downsample = <T>(arr: Array<T>, max: number): Array<T> => {
  if (arr.length <= max) return arr;
  const step = (arr.length - 1) / (max - 1);
  const result: Array<T> = [];

  for (let i = 0; i < max; i++) {
    result.push(arr[Math.round(i * step)]);
  }

  return result;
};

export const toNivoHeatmap = (raw: PreciseHeatmapApiResponse): PreciseHeatmapResponse => ({
  data: raw.series.map(s => ({
    id: decodeHtml(s.label),
    data: s.data.map((y, i) => ({
      x: raw.hours[i],
      y,
    })),
  })),
  coverage: {
    covered: raw.coverage.precise,
    total: raw.coverage.total,
  },
});

export const toNivoTimeseries = (raw: TimeseriesApiResponse) => {
  const dates = downsample(raw.dates, MAX_TIMESERIES_POINTS);
  const needsDownsample = raw.dates.length > MAX_TIMESERIES_POINTS;
  const step = needsDownsample ? (raw.dates.length - 1) / (MAX_TIMESERIES_POINTS - 1) : 1;

  return raw.series.map(s => ({
    id: decodeHtml(s.label),
    data: needsDownsample
      ? dates.map((date, i) => ({
          x: date,
          y: s.data[Math.round(i * step)],
        }))
      : s.data.map((y, i) => ({
          x: raw.dates[i],
          y,
        })),
  }));
};

export const toNivoRadar = (raw: ModalityRadarApiResponse): ModalityRadarResponse => ({
  availability: raw.availability,
  data: raw.modalities.map((modality, i) => ({
    modality: decodeHtml(modality),
    value: raw.values[i] ?? 0,
  })),
});
